/* Nuvò · Spedizioni — calcolatore costo e tempi di spedizione */
(function () {
  function num(v) {
    var n = parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
  }
  function fix(v) { return (Math.round(v * 100) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function plain(v) {
    var r = Math.round(v * 100) / 100;
    return (r % 1 === 0 ? String(r) : r.toFixed(2)).replace('.', ',') + ' €';
  }
  function init(root) {
    if (!root || root.__nsInit) return;
    root.__nsInit = true;
    var sel = root.querySelector('[data-ns-dest]');
    var inp = root.querySelector('[data-ns-amt]');
    if (!sel || !inp) return;
    var out = {};
    ['cost', 'time', 'msg'].forEach(function (k) { out[k] = root.querySelector('[data-ns-out="' + k + '"]'); });
    var bar = root.querySelector('[data-ns-bar]');
    var fill = bar ? bar.firstElementChild : null;
    function update() {
      var o = sel.options[sel.selectedIndex];
      if (!o) return;
      var cost = num(o.getAttribute('data-cost'));
      var free = num(o.getAttribute('data-free'));
      var n = num(inp.value);
      var ok = free > 0 && n >= free;
      var pct = free > 0 ? Math.round(Math.min(100, (n / free) * 100)) : 0;
      out.cost.textContent = ok ? root.getAttribute('data-free-label') : fix(cost);
      out.time.textContent = o.getAttribute('data-time') || '';
      out.msg.textContent = ok
        ? root.getAttribute('data-msg-ok')
        : (root.getAttribute('data-msg-miss') || '').replace('{mancano}', fix(free - n)).replace('{soglia}', plain(free));
      if (fill) fill.style.width = pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(pct));
    }
    sel.addEventListener('change', update);
    inp.addEventListener('input', update);
    inp.addEventListener('change', update);
    update();
  }
  function scan(scope) {
    (scope || document).querySelectorAll('[data-ns-calc]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
